var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.$vuetify.breakpoint.smAndUp ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('img', _vm._g({
          attrs: {
            "src": require("@/assets/tooltip.svg")
          }
        }, on))];
      }
    }], null, false, 1623786573)
  }, [_c('span', [_vm._v(_vm._s(_vm.content))])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }